import restaurantInstance from '../instance'

const updateDishCourses = (enabled, coursesCount) => {
	return restaurantInstance.put('/dishCourses', { enabled, coursesCount })
}

export default updateDishCourses
